var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragDrop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Drag Drop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Drag-Drop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    stroke: "#B7844D",
    strokeWidth: 0.35,
    fill: "#B7844D",
    points: "17.25531 6.75530994 16.6466509 7.35905511 19.3552092 10.0627835 10.9372166 10.0627835 10.9372166 1.64479084 13.6409449 4.35334916 14.2446901 3.74469003 10.5000001 0 6.75531004 3.74469003 7.35905521 4.35334916 10.0627836 1.64479084 10.0627836 10.0627835 1.64479096 10.0627835 4.35334927 7.35905511 3.74469015 6.75530994 0 10.5 3.74469015 14.24469 4.35334927 13.6409448 1.64479096 10.9372165 10.0627836 10.9372165 10.0627836 19.3552089 7.35905521 16.6466508 6.75531004 17.2553099 10.5000001 21 14.2446901 17.2553099 13.6409449 16.6466508 10.9372166 19.3552089 10.9372166 10.9372165 19.3552092 10.9372165 16.6466509 13.6409448 17.25531 14.24469 21 10.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragDrop);
export default __webpack_public_path__ + "static/media/DragDrop.e9857b1262a56623b620c6c5b05ced06.svg";
export { ForwardRef as ReactComponent };